/* =========================================================================
   iUROP — Banner de consentimiento de cookies para Gadea Loreak
   - Persiste la elección en localStorage ('gl-cookie-consent': 'accepted' /
     'rejected') → no se re-muestra tras elegir; reaparece solo sin elección.
   - Integra opcionalmente con window.Shopify.customerPrivacy (no bloqueante).
   - MURO DE CONSENTIMIENTO: mientras no haya elección, la web no se puede usar
     (capa que bloquea clics, scroll bloqueado, resto de la página inerte y foco
     atrapado en el banner). Se libera solo al pulsar Aceptar o Rechazar. No se
     bloquea en el editor de temas, en las páginas de políticas (para poder leer
     la política antes de elegir) ni para bots/rastreadores.
   - Accesible: role="dialog" aria-modal, el foco pasa al banner al aparecer,
     Esc NO cierra sin elegir.
   ========================================================================= */
(function () {
  'use strict';

  if (window.__iuropCookiesLoaded) return;
  window.__iuropCookiesLoaded = true;

  var STORAGE_KEY = 'gl-cookie-consent';
  var SHOW_DELAY = 700; // ms — deja respirar al primer render antes de aparecer

  /* ---- Acceso seguro a localStorage (modo privado / bloqueado) ---- */
  function readChoice() {
    try {
      return window.localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return null;
    }
  }
  function saveChoice(value) {
    try {
      window.localStorage.setItem(STORAGE_KEY, value);
    } catch (e) {
      /* almacenamiento no disponible: la elección solo dura esta sesión */
    }
  }

  /* ---- Consentimiento previo dado en el banner NATIVO de Shopify ----
     El banner nativo (privacy-banner/storefront-banner.js, activado en
     Admin > Configuración > Privacidad de clientes) guarda la elección vía
     customerPrivacy (cookie _tracking_consent), no en localStorage. Si el
     visitante ya eligió allí, se respeta como elección hecha y NO se
     re-muestra el nuestro. */
  function readNativeConsent() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp) return null;
      if (typeof cp.currentVisitorConsent === 'function') {
        var c = cp.currentVisitorConsent();
        if (c) {
          if (c.marketing === 'yes' || c.analytics === 'yes') return 'accepted';
          if (c.marketing === 'no' || c.analytics === 'no') return 'rejected';
        }
      }
      if (typeof cp.getTrackingConsent === 'function') {
        var t = cp.getTrackingConsent();
        if (t === 'yes' || t === '1') return 'accepted';
        if (t === 'no' || t === '0') return 'rejected';
      }
    } catch (e) { /* API de privacidad no disponible */ }
    return null;
  }

  /* ---- Acceso a la Customer Privacy API ----
     Shopify NO carga `consent-tracking-api.js` por su cuenta: hay que pedirlo
     con Shopify.loadFeatures. Sin esto, `Shopify.customerPrivacy` no existe y
     la elección del visitante NUNCA se registra (la cookie _tracking_consent
     no se escribe y el bloqueo de analytics/marketing no se libera). */
  function withCustomerPrivacy(cb) {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.setTrackingConsent === 'function') { cb(cp); return; }
      if (!(window.Shopify && typeof window.Shopify.loadFeatures === 'function')) return;
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function (err) {
          if (err) return;
          var loaded = window.Shopify && window.Shopify.customerPrivacy;
          if (loaded && typeof loaded.setTrackingConsent === 'function') cb(loaded);
        }
      );
    } catch (e) {
      /* API de privacidad no disponible: solo persistencia local */
    }
  }

  /* ---- Registrar la elección en el consent nativo de Shopify ---- */
  function applyShopifyConsent(granted) {
    withCustomerPrivacy(function (cp) {
      try {
        cp.setTrackingConsent(
          {
            analytics: granted,
            marketing: granted,
            preferences: granted,
            sale_of_data: granted
          },
          function () {}
        );
      } catch (e) { /* no bloquea la UI del banner */ }
    });
  }

  /* ---- Muro: bloquear el uso de la web hasta que se elija ---- */
  var LOCK_CLASS = 'iurop-cookies-lock';
  var inerted = [];
  var backdrop = null;
  var keyHandler = null;
  var observer = null;

  function shouldWall() {
    try {
      if (window.Shopify && window.Shopify.designMode) return false;       // editor de temas
      if (/bot|crawl|spider|slurp|lighthouse|headless|prerender/i.test(navigator.userAgent || '')) return false;
      if (navigator.webdriver) return false;
      if (/^\/([a-z]{2}(-[a-z]{2})?\/)?(policies|pages\/(politica|privacidad|cookies|aviso|terminos|condiciones))/i.test(window.location.pathname)) return false;
    } catch (e) { /* ante la duda, se bloquea */ }
    return true;
  }

  function lockPage(banner) {
    backdrop = document.createElement('div');
    backdrop.className = 'iurop-cookies__backdrop';
    backdrop.setAttribute('aria-hidden', 'true');
    document.body.appendChild(backdrop);
    document.documentElement.classList.add(LOCK_CLASS);

    // Resto de la página inerte: sin clics, sin foco por teclado y fuera del árbol accesible.
    function makeInert(el) {
      if (el === banner || el === backdrop || el.nodeType !== 1) return;
      if (el.tagName === 'SCRIPT' || el.tagName === 'STYLE' || el.tagName === 'LINK') return;
      if (el.hasAttribute('inert')) return;
      el.setAttribute('inert', '');
      inerted.push(el);
    }
    Array.prototype.forEach.call(document.body.children, makeInert);

    // Popups de apps (p. ej. el formulario de Klaviyo) se inyectan en el body DESPUÉS
    // de cargar: también quedan inertes mientras el muro esté activo.
    if (window.MutationObserver) {
      observer = new MutationObserver(function (records) {
        records.forEach(function (r) { Array.prototype.forEach.call(r.addedNodes, makeInert); });
      });
      observer.observe(document.body, { childList: true });
    }

    // Foco atrapado en el banner (Tab / Shift+Tab ciclan entre sus botones y el enlace).
    keyHandler = function (e) {
      if (e.key !== 'Tab') return;
      var f = banner.querySelectorAll('a[href], button');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1], active = document.activeElement;
      if (!banner.contains(active)) { e.preventDefault(); first.focus(); return; }
      if (e.shiftKey && active === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
    };
    document.addEventListener('keydown', keyHandler, true);

    banner.setAttribute('role', 'dialog');
    banner.setAttribute('aria-modal', 'true');
  }

  function unlockPage() {
    document.documentElement.classList.remove(LOCK_CLASS);
    if (observer) { observer.disconnect(); observer = null; }
    inerted.forEach(function (el) { el.removeAttribute('inert'); });
    inerted = [];
    if (keyHandler) { document.removeEventListener('keydown', keyHandler, true); keyHandler = null; }
    if (backdrop) {
      var b = backdrop; backdrop = null;
      b.classList.remove('is-visible');
      setTimeout(function () { if (b.parentNode) b.remove(); }, 350);
    }
  }

  function init() {
    var banner = document.getElementById('iurop-cookies');
    if (!banner) return;

    // Precargar la Customer Privacy API: al pulsar Aceptar/Rechazar ya está
    // disponible y el consentimiento se registra sin depender de la red.
    withCustomerPrivacy(function () {});

    var acceptBtn = banner.querySelector('[data-cookie-accept]');
    var rejectBtns = banner.querySelectorAll('[data-cookie-reject]');

    // Si ya hay elección previa, no mostrar y sacarlo del árbol accesible.
    var previous = readChoice();
    if (previous === 'accepted' || previous === 'rejected') {
      banner.remove();
      return;
    }

    // Migración: elección ya hecha en el banner nativo de Shopify → se
    // persiste en nuestra clave y no se re-pregunta.
    var native = readNativeConsent();
    if (native) {
      saveChoice(native);
      banner.remove();
      return;
    }

    var shown = false;

    // Sin elección previa: la web queda bloqueada desde ya (antes incluso de que
    // aparezca el banner), para que nadie navegue sin haber decidido.
    if (shouldWall()) lockPage(banner);

    function show() {
      if (shown) return;
      shown = true;
      if (backdrop) {
        // eslint-disable-next-line no-unused-expressions
        backdrop.offsetHeight;
        requestAnimationFrame(function () { if (backdrop) backdrop.classList.add('is-visible'); });
      }
      banner.hidden = false;
      banner.setAttribute('aria-hidden', 'false');
      // Fuerza reflow para que la transición de entrada se dispare.
      // eslint-disable-next-line no-unused-expressions
      banner.offsetHeight;
      requestAnimationFrame(function () {
        banner.classList.add('is-visible');
      });
      // El foco pasa al banner (una sola vez) para lectores de pantalla.
      if (acceptBtn && typeof acceptBtn.focus === 'function') {
        try { acceptBtn.focus({ preventScroll: true }); } catch (e) { acceptBtn.focus(); }
      }
    }

    function dismiss(choice) {
      unlockPage();
      saveChoice(choice);
      applyShopifyConsent(choice === 'accepted');
      banner.classList.remove('is-visible');
      banner.setAttribute('aria-hidden', 'true');

      try {
        document.dispatchEvent(
          new CustomEvent('gl:cookie-consent', { detail: { choice: choice } })
        );
      } catch (e) { /* CustomEvent no soportado: silencioso */ }

      var remove = function () { if (banner && banner.parentNode) banner.remove(); };
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) {
        remove();
      } else {
        var done = false;
        var finish = function () { if (done) return; done = true; remove(); };
        banner.addEventListener('transitionend', finish, { once: true });
        setTimeout(finish, 400); // salvaguarda si transitionend no dispara
      }
    }

    if (acceptBtn) acceptBtn.addEventListener('click', function () { dismiss('accepted'); });
    Array.prototype.forEach.call(rejectBtns, function (btn) {
      btn.addEventListener('click', function () { dismiss('rejected'); });
    });

    // Esc NO cierra sin elegir (requisito de accesibilidad): sin handler de teclado.

    if (SHOW_DELAY > 0) {
      setTimeout(show, SHOW_DELAY);
    } else {
      show();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
